import { CostLegend, CostStack } from '../../components/charts/CostStack';
import { GradeBadge } from '../../components/GradeBadge';
import { Panel } from '../../components/ui';
import { pct, usd, usdT } from '../../lib/format';
import type { RunResult } from '../../types/api';

export function OptionsTable({ run, selected, onSelect }: { run: RunResult; selected: string; onSelect: (key: string) => void }) {
  const max = Math.max(...run.results.map((r) => Math.max(r.all_in_cost_usd_t, r.revenue_usd_t))) * 1.04;
  return (
    <Panel
      title="Ranked options"
      description="Weighted score: IRR 40%, all-in cost 25%, carbon 15%, risk 20%. Select a row for detail."
      flush
      note={<CostLegend />}
    >
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>#</th><th>Location / route</th><th>All-in cost vs revenue</th>
              <th className="num">Breakeven</th><th className="num">IRR</th><th className="num">NPV</th><th className="num">Score</th><th>Data</th>
            </tr>
          </thead>
          <tbody>
            {run.results.map((r) => (
              <tr key={r.key} className={`selectable${r.key === selected ? ' selected' : ''}`} onClick={() => onSelect(r.key)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(r.key); } }}
                tabIndex={0} aria-selected={r.key === selected}>
                <td><span className={`rank-pill${r.rank === 1 ? ' first' : ''}`}>{r.rank}</span></td>
                <td>
                  <div className="option-name">
                    <strong>{r.location_name}{r.tie_group && <span className="tie-tag" title="Economically tied with other options">TIE {r.tie_group}</span>}</strong>
                    <span>{r.route_name}{r.route_illustrative ? ' · illustrative' : ''}</span>
                  </div>
                </td>
                <td className="cost-cell">
                  <CostStack option={r} max={max} />
                  <span className="tiny muted num">{usdT(r.all_in_cost_usd_t)} all-in · {usdT(r.revenue_usd_t)} revenue</span>
                </td>
                <td className="num"><strong>{usdT(r.breakeven_lioh_price_usd_t)}</strong></td>
                <td className="num" style={{ color: r.irr != null && r.irr >= r.wacc ? 'var(--good)' : undefined }}>{pct(r.irr)}</td>
                <td className="num">{usd(r.npv_usd)}</td>
                <td className="num">{r.score.toFixed(1)}</td>
                <td><GradeBadge grade={r.confidence.worst} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Panel>
  );
}
